import { UserProfileEntryProps } from '@ixicare/resources';
import { SortAccessor } from '../DeviceTables/types';

export type ProfileSortAccessor = SortAccessor<UserProfileEntryProps>;

// presence_state is not handled here — presence lives in the MobX `presence`
// store, not on the profile entry, so the component re-sorts after this hook.
export const profileSortAccessors: Record<string, ProfileSortAccessor> = {
  first_name: (p) => p.firstName?.toLowerCase() ?? null,
  last_name: (p) => p.lastName?.toLowerCase() ?? null,
  created: (p) => (p.created ? new Date(p.created).getTime() : null),
  device: (p) => p.ownedDevice?.deviceType ?? null,
  device_updated_at: (p) =>
    p.ownedDevice?.status?.updatedOn ? new Date(p.ownedDevice.status.updatedOn).getTime() : null,
};
